<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      :show-save-button="!readonly"
      title="管理班级"
      id-key="TeacherId"
      :data="data"
      form-label-width="100px"
      @opened="onOpened"
      :save-func="teacher_api.saveMsg"
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="消息类型">
              <el-checkbox label="学生考勤异常" v-model="data.AttendanceMsg" :disabled="readonly"></el-checkbox>
              <el-checkbox label="学生就医" v-model="data.MedicalMsg" :disabled="readonly"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="接收消息人员">
              <span>{{data.TeacherName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期" prop="TermId">
              <el-select v-model="data.TermId" size="mini" @change="getClass" :disabled="readonly">
                <template v-for="(i,index) in terms">
                  <el-option :key="index" :value="i.TermId" :label="i.TermName"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider class="msgText">选择班级</el-divider>
        <el-row>
          <el-tree
            ref="class_tree"
            node-key="Id"
            :data="classes"
            show-checkbox
            :default-expanded-keys="this.data.ClassIds"
            :props="tree_option"
          ></el-tree>
        </el-row>
      </template>
      <template slot="footer" v-if="readonly">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      class_api: require("@/api/ed/class").default,
      term_api: require("@/api/ed/term").default,
      teacher_api: require("@/api/fa/teacher").default,
      isMB: this.$store.state.isMB,
      readonly: !this.$permission.canWrite(),
      terms: [],
      classes: [],
      tree_option: {
        children: "children",
        label: "Name",
      },
      data: {
        TeacherId: null,
        TeacherName: "",
        TermId: 0,
        AttendanceMsg: false,
        MedicalMsg: false,
        ClassIds: [],
      },
    };
  },
  computed: {},
  methods: {
    onOpened(data) {
      this.data.TeacherId = data.TeacherId;
      this.data.TeacherName = data.TeacherName;
      this.data.MedicalMsg = data.MedicalMsg;
      this.data.AttendanceMsg = data.AttendanceMsg;

      this.term_api.list().then((res) => {
        this.terms = res.Data;
        if (this.terms.length > 0) {
          this.data.TermId = this.terms[0].TermId;
          this.getClass();
        }
      });
    },
    getClass() {
      this.class_api.list({ TermId: this.data.TermId }).then((res) => {
        console.log("classes", res);
        this.classes = [];
        var grades = toArr(res.Data.map((x) => x.GradeId));
        function toArr(old_arr) {
          var arr = new Set(old_arr);
          var new_arr = Array.from(arr);
          return new_arr;
        }
        grades.forEach((i) => {
          var classes = res.Data.filter((x) => x.GradeId == i);
          var grade = {
            Id: i * -1,
            Name: classes[0].Grade,
            disabled: this.readonly,
            children: [],
          };
          grade.children = classes.map((x) => {
            return {
              Id: x.ClassId,
              Name: grade.Name + x.Class,
              Pid: grade.Id,
              disabled: this.readonly,
            };
          });
          this.classes.push(grade);
        });
      });
      // if(this.readonly) {
      //   console.log('rrr')
      //   this.classes.forEach(item => {
      //     item.disabled = true
      //     if(item.children) {
      //       item.children.forEach(e => {
      //         e.disabled = true
      //       })
      //     }
      //   })
      // }
      this.getMsgClasses();
    },
    getMsgClasses() {
      var params = { TermId: this.data.TermId, TeacherId: this.data.TeacherId };
      this.teacher_api.getMsgClassIds(params).then((res) => {
        console.log(res);
        this.data.ClassIds = res.Data;
        this.$refs.class_tree.setCheckedKeys(this.data.ClassIds);
      });
    },
    onBeforeSave() {
      if (this.data.MedicalMsg == false && this.data.AttendanceMsg == false) {
        this.$message.warning("请选择消息类型");
        return false;
      }
      var nodes = this.$refs.class_tree.getCheckedNodes();
      if (nodes.length == 0) {
        this.$message.warning("请选择接收消息的班级");
        return false;
      }
      var keys = nodes.filter((x) => x.Pid != undefined).map((x) => x.Id);
      this.data.ClassIds = keys;

      return true;
    },
    onClosed() {
      this.classes = [];
      this.terms = [];
    },
  },
};
</script>
<style lang="scss">
.msgText {
  .el-divider__text {
    white-space: nowrap;
  }
}
</style>